import AnalyzeGrantToolRenderer from './renderers/analyze-grant';
import GenericToolRenderer from './renderers/generic';
import SearchGrantsToolRenderer from './renderers/search-grants';
import SQLToolBodyRenderer from './renderers/sql/BodyRenderer';
import WebSearchToolRenderer from './renderers/web-search';
const TOOL_CARD_RENDERERS = {
    generic: GenericToolRenderer,
    search_grants: SearchGrantsToolRenderer,
    web_search: WebSearchToolRenderer,
    sql: SQLToolBodyRenderer,
    analyze_grant: AnalyzeGrantToolRenderer,
};
export const getToolCardRenderer = (displayVariant) => {
    return TOOL_CARD_RENDERERS[displayVariant];
};
